// extracted by mini-css-extract-plugin
module.exports = {"textPanel":"ExplanationPanel_textPanel__1mtry","showTextPanel":"ExplanationPanel_showTextPanel__64Bow","textPanelContent":"ExplanationPanel_textPanelContent__2NS3B"};